import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';
import { Col, Row } from 'antd';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ReactComponent as DocsListIcon } from '../../../../../assets/icons/docs-list.svg';
import { ReactComponent as FilesIcon } from '../../../../../assets/icons/files-records.svg';
import { ReactComponent as NotesIcon } from '../../../../../assets/icons/notes.svg';
import { ReactComponent as SearchIcon } from '../../../../../assets/icons/search-icon.svg';
import { ReactComponent as ShipmentIcon } from '../../../../../assets/icons/shipment-file.svg';
import { ReactComponent as TruckIcon } from '../../../../../assets/icons/truck.svg';
import { routeFileSelector } from '../../../../../utilz/i18n';
import SvgConverter from '../../../../components/Common/SvgConverter';
import CollapsiblePanel from '../../../../components/Tabs/CollapsiblePanel';
import { TAB_KEYS } from '../../constants';
import QuoteBiddingLogs from '../Tabs/BiddingLogs/QuoteBiddingLogs';
import QuoteCollaboratorLogs from '../Tabs/CollboratorLogs/QuoteCollaboratorLogs';
import HallDocumentDetails from './Tabs/DocumentDetails/HallDocumentDetails';
import HallNotesDetails from './Tabs/NotesDetails/HallNotesDetails';
import HallProductDetails from './Tabs/ProductDetails/HallProductDetails';
import HallQuoteDetailsForm from './Tabs/QuoteDetails/HallQuoteDetailsForm';
import ShippingTermsSearchForm from './Tabs/ShippingTerms/ShippingTermsSearchForm';
import HallTransportationDetails from './Tabs/TransportationDetails/HallTransportationDetails';

const GenerateTitle = ({ title, Icon, size = 25 }) => {
  return (
    <Row gutter={10} align="middle">
      <Col className="lh-0">
        <SvgConverter width={size} height={size} Icon={Icon} />
      </Col>
      <Col className="lh-0">
        {/* biome-ignore lint/a11y/noLabelWithoutControl: <explanation> */}
        <label className="lh-0 text-dark cursor-pointer">{title}</label>
      </Col>
    </Row>
  );
};

const HallCreateGetQuoteTabs = ({ activeKey, setActiveKey }) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);
  const { copyQuoteKey } = useSelector((state) => state.common);

  const handleTabClick = (keys) => {
    setActiveKey(keys);
  };

  useEffect(() => {
    if (copyQuoteKey) {
      showNotification({
        type: NOTIFICATION_TYPES.SUCCESS,
        message: 'Quote was successfully copied',
      });
    }
  }, []);

  return (
    <CollapsiblePanel
      forceRender
      handleTabClick={handleTabClick}
      activeKey={activeKey}
      tabs={[
        {
          content: <HallQuoteDetailsForm />,
          tabKey: TAB_KEYS.quoteDetails,
          header: <GenerateTitle title={t('translation:getQuote.titles.quoteDetails')} Icon={ShipmentIcon} size={25} />,
        },
        {
          content: <HallTransportationDetails />,
          tabKey: TAB_KEYS.transportationDetails,
          header: (
            <GenerateTitle title={t('translation:getQuote.titles.transportationDetails')} Icon={TruckIcon} size={25} />
          ),
        },
        {
          content: <HallProductDetails />,
          tabKey: TAB_KEYS.productDetails,
          header: (
            <GenerateTitle title={t('translation:default.fields.productDetails')} Icon={DocsListIcon} size={25} />
          ),
        },
        {
          content: <ShippingTermsSearchForm />,
          tabKey: TAB_KEYS.shippingTerms,
          header: <GenerateTitle title="Shipping Terms" Icon={SearchIcon} size={25} />,
        },

        {
          content: <HallNotesDetails />,
          tabKey: TAB_KEYS.notes,
          header: <GenerateTitle title={t('translation:getQuote.titles.quoteNotes')} Icon={NotesIcon} size={25} />,
        },
        {
          content: <HallDocumentDetails />,
          tabKey: TAB_KEYS.documents,
          header: <GenerateTitle title={t('translation:default.documentManager.title')} Icon={FilesIcon} size={25} />,
        },

        {
          content: <QuoteCollaboratorLogs />,
          tabKey: TAB_KEYS.collaborators,
          header: <GenerateTitle title="Collaborators" Icon={NotesIcon} size={25} />,
          hidePadding: true,
        },

        {
          content: <QuoteBiddingLogs />,
          tabKey: TAB_KEYS.bidding,
          header: <GenerateTitle title="Bidding" Icon={NotesIcon} size={25} />,
          hidePadding: true,
        },
      ]}
    />
  );
};

export default HallCreateGetQuoteTabs;
